// @ts-expect-error untyped module
import { push } from '../../utils/history';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H3 } from 'foundations-components/transitional/components/H3';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import { getCredentialDisplayName } from 'marketplace-ui-common/utils/credentials';
import { useContext, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ACCREDITATION_CARD_IDS } from '../../constants/HomepageIconMap';
import * as FilterKey from '../../constants/search/FilterKey';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { getAccreditations } from '../../selectors/accreditations';
import { fromFilterStateToLocation } from '../../utils/storefrontFilters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HomepageAccreditationCardGrid() {
  const {
    trackInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const [selectedAccreditation, setSelectedAccreditation] = useState(null); // used for definition modal
  const accreditations = useSelector(getAccreditations);
  const lang = getLang();
  const {
    gridColumnCount
  } = useResponsiveProps({
    gridColumnCount: {
      lg: 2,
      sm: 1
    }
  });
  const renderedAccreditationCards = useMemo(() => {
    return ACCREDITATION_CARD_IDS.map(accreditationId => {
      const accreditation = accreditations.filter(acc => acc.id === accreditationId)[0];
      if (!accreditation) {
        return null;
      }
      const accreditationName = getCredentialDisplayName(accreditation, lang);
      const accreditationTrackingName = getCredentialDisplayName(accreditation, 'en');
      return /*#__PURE__*/_jsx(CardWrapper, {
        children: /*#__PURE__*/_jsxs(CardSection, {
          children: [/*#__PURE__*/_jsx(MediaQueryView, {
            min: "md",
            children: /*#__PURE__*/_jsxs(TFlex, {
              direction: "column",
              children: [/*#__PURE__*/_jsx(MediaObject, {
                align: "stretch",
                itemRight: /*#__PURE__*/_jsx(Image, {
                  inlineSize: "125px",
                  responsive: false,
                  src: accreditation.icon
                }),
                children: /*#__PURE__*/_jsxs(TFlex, {
                  direction: "column",
                  justify: "between",
                  children: [/*#__PURE__*/_jsx(H3, {
                    minBlockSize: "40px",
                    overflowWrap: "anywhere",
                    role: "presentation",
                    children: accreditationName
                  }), /*#__PURE__*/_jsxs("p", {
                    children: [/*#__PURE__*/_jsx(FormattedMessage, {
                      message: `ecosystem-marketplace-solutions-ui.homepage.accreditations.accreditation${accreditation.id}.shortDescription`
                    }), ' ', /*#__PURE__*/_jsx(Button, {
                      onClick: () => {
                        trackInteraction('click homepage accreditation card learn more', {
                          feature: FilterKey.ACCREDITATION,
                          item_type: accreditationTrackingName || accreditation.id
                        });
                        setSelectedAccreditation(accreditation);
                      },
                      use: "link",
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: `ecosystem-marketplace-solutions-ui.homepage.accreditations.learnMore`
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: () => {
                  trackInteraction('click homepage accreditation card', {
                    feature: FilterKey.ACCREDITATION,
                    item_type: accreditation.id
                  });
                  push(fromFilterStateToLocation({
                    accreditation: [accreditation.id.toString(10)]
                  }, []));
                },
                size: "small",
                use: "tertiary",
                marginBlockStart: "400",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.findButton",
                  options: {
                    accreditationName
                  }
                })
              })]
            })
          }), /*#__PURE__*/_jsx(MediaQueryView, {
            max: "md",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsx(Image, {
                inlineSize: "125px",
                paddingBlockEnd: "600",
                responsive: false,
                src: accreditation.icon
              }), /*#__PURE__*/_jsx(H3, {
                role: "presentation",
                children: accreditationName
              }), /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `ecosystem-marketplace-solutions-ui.homepage.accreditations.mobileCardSubtitle`,
                  options: {
                    accreditationName
                  }
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: () => setSelectedAccreditation(accreditation),
                use: "link",
                paddingInlineStart: "100",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `ecosystem-marketplace-solutions-ui.homepage.accreditations.whatIs`,
                  options: {
                    accreditationName
                  }
                })
              }), /*#__PURE__*/_jsx(Button, {
                onClick: () => {
                  trackInteraction('click homepage accreditation card', {
                    feature: FilterKey.ACCREDITATION,
                    item_type: accreditationTrackingName || accreditation.id
                  });
                  push(fromFilterStateToLocation({
                    accreditation: [accreditation.id.toString(10)]
                  }, []));
                },
                size: "small",
                use: "tertiary",
                marginBlockStart: "400",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.findButton",
                  options: {
                    accreditationName
                  }
                })
              })]
            })
          })]
        })
      }, accreditation.id);
    });
  }, [accreditations, lang, trackInteraction]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(H3, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.title"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.tooltip"
        }),
        tooltipPlacement: "right",
        paddingInlineStart: "400"
      })]
    }), /*#__PURE__*/_jsxs("p", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.subtitle"
      }), /*#__PURE__*/_jsx(Link, {
        href: "https://academy.hubspot.com/accreditations",
        external: true,
        onClick: () => trackInteraction('click accreditation learn more'),
        paddingInlineStart: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.accreditations.learnMore"
        })
      })]
    }), /*#__PURE__*/_jsx(ExpandableText, {
      fadeOutHeight: 50,
      maxHeight: 425,
      onExpandButtonClick: () => {
        trackInteraction('click to expand accreditation see more');
      },
      children: /*#__PURE__*/_jsx(CardGrid, {
        columns: gridColumnCount,
        marginBlockEnd: "600",
        children: renderedAccreditationCards
      })
    }), selectedAccreditation && /*#__PURE__*/_jsxs(Modal, {
      use: "conversational",
      width: 600,
      centered: false,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h3",
          textAlign: "left",
          children: getCredentialDisplayName(selectedAccreditation, lang)
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => setSelectedAccreditation(null)
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(Text, {
          textAlign: "left",
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `ecosystem-marketplace-solutions-ui.homepage.accreditations.accreditation${selectedAccreditation.id}.fullDescription`
          })
        })
      })]
    })]
  });
}